import React from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import TaskForm from "./taskComponents/TaskForm";

import { useCreateTaskMutation } from "store/services/taskApi";

import { useAppMeta } from "hooks";

const TaskCreateScreen = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Tasks", path: "/app/crm/task/list" },
    {
      title: "New Task",
    },
  ];

  //   RTK Query
  const [createTask, { isLoading: creatingTask }] = useCreateTaskMutation();

  // methods
  const handleCreateTask = async (data) => {
    try {
      const { _id } = await createTask({ ...data }).unwrap();
      navigate(`/app/crm/task/${_id}/detail`);
      toast.success("Task created successfully!");
    } catch (err) {
      toast.error(err?.data?.message ?? "Couldn't create Task!");
    }
  };

  useAppMeta("New Task");

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingTask}>
      <BreadcrumbLayout.Paper>
        <TaskForm isBusy={creatingTask} onSubmit={handleCreateTask} />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default TaskCreateScreen;
